import { Duration } from "luxon";

/** A call's length, rounded to the nearest minute (e.g. `3m`, `1h 5m`). */
export function renderCallDuration(seconds: number): string {
  if (seconds === 0) {
    return "--";
  }

  const minutes = Math.max(
    1,
    Math.round(Duration.fromObject({ seconds }).as("minutes")),
  );

  return minutes < 60
    ? `${minutes}m`
    : Duration.fromDurationLike({ minutes }).rescale().toFormat("h'h' m'm'");
}

export function renderDuration(seconds: number): string {
  const duration = Duration.fromMillis(seconds * 1000);

  if (duration.as("hours") >= 1) {
    return duration.toFormat("h:mm:ss");
  }

  return duration.toFormat("m:ss");
}
